import { GroupedGridColDef } from '../UpstackDataGrid/gridColumnTypes';
import { DefaultInventoryGridColumnDefs } from '../../Pages/Inventory/inventoryGridColumnDefs';
import { DefaultCaseGridColumnDefs } from '../../Pages/SupportCases/SupportCaseGridColDefs';
import { WorkflowBaseColumns } from '../../Pages/Orders/WorkflowOrdersGridColumnDefs';
import { DefaultProjectGridColumnsDefs } from '../../Pages/Projects/projectGridColumnsDefs';
import { PermissionSetDomain } from '../../../types';

// Built-in maskable fields per domain, mirrored from each table's MUI grid column defs (`field` = API `hide_fields` key).
export interface BuiltInField {
  field: string;
  label: string;
}

const NON_MASKABLE_FIELDS = ['details', 'detailCTA', 'tags'];

const toBuiltInFields = (columns: GroupedGridColDef[]): BuiltInField[] =>
  columns
    .filter((col) => col.hideable !== false && !NON_MASKABLE_FIELDS.includes(col.field) && !!col.headerName)
    .map((col) => ({ field: col.field, label: col.headerName as string }));

const CATALOG: Record<PermissionSetDomain, BuiltInField[]> = {
  inventory: toBuiltInFields(DefaultInventoryGridColumnDefs),
  cases: toBuiltInFields(DefaultCaseGridColumnDefs),
  orders: toBuiltInFields(WorkflowBaseColumns),
  projects: toBuiltInFields(DefaultProjectGridColumnsDefs),
  reports: []
};

export const getBuiltInFields = (domain: PermissionSetDomain): BuiltInField[] => CATALOG[domain] ?? [];
